// src/store/thunks/authThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { loginUser, refresh_token } from '../../services/auth';

// Async thunks for authentication
export const login = createAsyncThunk(
  'auth/login',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await loginUser({ email, password });
      localStorage.setItem('token', JSON.stringify(response.data.tokenData));

      return { token: response.data.tokenData, user: response.data.userData };
    } catch (error) {
      return rejectWithValue(error?.response?.data?.error || error.message);
    }
  }
);

export const register = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      // Mock registration
      const user = { 
        id: 3, 
        name: `${userData.firstName} ${userData.lastName}`, 
        email: userData.email, 
        role: 'admin' 
      };
      const token = 'mock_token_789';
      
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', token);
      
      return { user, token };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async () => {
    localStorage.removeItem('token');
    return null;
  }
);

// Async thunks for refreash token
export const refreshToken = createAsyncThunk(
  'auth/refresh',
  async ({}, { rejectWithValue }) => {
    try {
      const response = await refresh_token();
      localStorage.setItem('token', JSON.stringify(response.data.tokenData));

      return { token: response.data.tokenData, user: response.data.userData };
    } catch (error) {
      localStorage.removeItem('token');
      return rejectWithValue('');
    }
  }
);